module.exports = __webpack_public_path__ + "3bc6f6b2897ab0cc2ff10a9404ad276d.png";